module.exports = __webpack_public_path__ + "static/organicspotmulti-b61dcca1801480b9dea257f79bb2d2eb.jpeg";